import React from 'react';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context';
import { AppShell, LandingRedirect, MonitorGate, ProtectedRoute, SuperadminGate } from './components';
import { AuthCallback, Dashboard, HubSyncLogs, LastFetch, Leaderboard, Login, Pipeline, PromptDetail, ScoringRun, UserRoles } from './pages';
import './App.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              {/* MyPatterns stays in pages/. Direct visits go to Prompts. */}
              <Route path="/patterns" element={<Navigate to="/dashboard" replace />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/prompts/:promptId" element={<PromptDetail />} />
              <Route
                path="/pipeline"
                element={
                  <MonitorGate>
                    <Pipeline />
                  </MonitorGate>
                }
              />
              <Route
                path="/pipeline/runs/:runId"
                element={
                  <MonitorGate>
                    <ScoringRun />
                  </MonitorGate>
                }
              />
              <Route
                path="/last-fetch"
                element={
                  <MonitorGate>
                    <LastFetch />
                  </MonitorGate>
                }
              />
              <Route
                path="/hub-sync-logs"
                element={
                  <MonitorGate>
                    <HubSyncLogs />
                  </MonitorGate>
                }
              />
              {/* Analytics, Score mix and Low scores stay in pages/. Direct visits go to Prompts. */}
              <Route path="/analytics" element={<Navigate to="/dashboard" replace />} />
              <Route path="/analytics/score-mix" element={<Navigate to="/dashboard" replace />} />
              <Route path="/analytics/low-scores" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/admin/roles"
                element={
                  <SuperadminGate>
                    <UserRoles />
                  </SuperadminGate>
                }
              />
            </Route>

            <Route path="/" element={<LandingRedirect />} />
            <Route path="*" element={<LandingRedirect />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
